import * as React from "react"
import { Kbd } from "@design/ui/kbd"

export interface TooltipWiring {
  tooltipShowCaret?: boolean
  tooltipLabel?: string
  tooltipShowKbd?: boolean
  kbd: Omit<React.ComponentProps<typeof Kbd>, "className" | "children">
  kbdShowLeftIcon?: boolean
  kbdLabel?: string
  kbdShowRightIcon?: boolean
}

export const TooltipContext = React.createContext<TooltipWiring | null>(null)

export function useWiring(): TooltipWiring {
  const wiring = React.useContext(TooltipContext)
  if (wiring === null) {
    throw new Error("TooltipScreen: render inside <TooltipContext.Provider>")
  }
  return wiring
}
